import root from 'window-or-global';

export const scrollTo = (to: number, duration: number): void => {
    if (duration <= 0 || !root.document) return;
    const scrollTop =
        root.pageYOffset || root.document.documentElement.scrollTop || root.document.body.scrollTop;
    const difference = to - scrollTop;
    const perTick = difference / duration;

    setTimeout(() => {
        root.document.documentElement.scrollTop += perTick * 20;
        root.document.body.scrollTop += perTick * 20;
        if (root.document.body.scrollTop === to) return;

        scrollTo(to, duration - 10);
    }, 10);
};
